module.exports = __webpack_public_path__ + "img/style-tile-mobile.c39fa165.png";